import { tns } from '../../_scripts/plugins/tiny-slider/tiny-slider.js';

export default class FilterSearch {

  constructor(form) {
    this.targetForm = form;
    this.selectOptions;
    this.filterSearch = document.querySelector('.filter-search');
    this.slideLine;
    this.filterSelect = document.querySelector('.filter-search__select');
    this.filterSearchList;
    this.slider;
    this.activeItem;
    this.maxFilterItems;
    this.landscapeActive = false;
    this.createFilters = true;
    this._checkOrientation();
  }

  _removeClassActive() {
    [...this.filterSearch.querySelectorAll('.filter-search__item')].map(item => {
      item.classList.remove('filter-search__item--active');
    });

    [...this.selectOptions].map(option => {
      option.removeAttribute('selected');
    });
  };

  _getNumberSlide(currentItem) {
    const slideNumber = Number(currentItem.dataset.id);
    setTimeout(() => {

      this.slider.goTo(slideNumber);
    }, 1);
  }

  _tinySlider() {
    const slider = tns({
      autoWidth: true,
      loop: false,
      mouseDrag: true,
      container: this.filterSearchList,
      controls: false,
      swipeAngle: false,
      speed: 400,
      nav: false,
      autoPlay: false,
      responsive: {
        1025: {
          disable: true
        },
      }
    });

    this.slider = slider;
  }

  _addClassActive(target) {
    this._removeClassActive();

    target.classList.add('filter-search__item--active');
    this.filterSelect.querySelector(`[data-id="${target.getAttribute('data-id')}"]`).setAttribute('selected', '');

    this.activeItem = target;

    this.landscapeActive
      ? this._getNumberSlide(target)
      : this._setStylesSlideLine(target);
  };

  _setStylesSlideLine(item) {
    const targetItem = item.firstChild;
    this.slideLine = document.querySelector('.filter-search__slide-line');

    if (item.classList.contains('submenu__item')) {
      this.slideLine.style.width = '0';
      this.slideLine.style.left = '100%';
    }
    else {
      let itemOffsetLeft = targetItem.offsetLeft;
      let itemOffsetWidth = !item.classList.contains('filter-search__item--active') ? targetItem.offsetWidth : 0;
      this.slideLine.style.width = `${itemOffsetWidth}px`;
      this.slideLine.style.left = `${itemOffsetLeft}px`;
    }
  };

  _addUnderlineMenu() {
    const activeItem = this.filterSearchList.querySelector(`[data-id="${this.filterSelect.querySelector('[selected]').dataset.id}"]`);
    this._setStylesSlideLine(activeItem);
    this.activeItem = activeItem;

    [...this.filterSearch.querySelectorAll('.filter-search__item')].map(item => {

      item.addEventListener('mouseover', () => {
        this._setStylesSlideLine(item.closest('.filter-search__item'));
      });

      item.addEventListener('mouseout', e => {
        this.activeItem
          && this._setStylesSlideLine(this.activeItem);
      });
    });
  };

  _checkOrientation() {
    if (window.innerWidth > 1360) {
      this.maxFilterItems = 8;
      this._createSelectOptions(window.orientation);
    }
    else if (window.innerWidth < 1360 && window.innerWidth > 1024) {
      this.maxFilterItems = 6;
      this._createSelectOptions(window.orientation);
    }
    else if (window.innerWidth <= 1024) {
      this.landscapeActive = true;
      this.createFilters
        && this._createSelectOptions(window.orientation);

      this._tinySlider();
      this._addClassActive(this.filterSearchList.querySelector(`[data-id="${this.filterSelect.querySelector('[selected]').dataset.id}"]`));
    }
  }

  _activeAllVisibleFilters() {
    [...this.filterSearch.querySelectorAll('.filter-search__item')].map(item => {
      item.removeAttribute('style');
    });
  }

  _createSelectOptions(orientationType) {
    this.selectOptions = this.filterSelect.getElementsByTagName('option');

    const submenu = `
      <div class="submenu">
        <svg viewBox="0 0 26 6" class="more-svg">
          <use xlink:href="#more"></use>
        </svg>
        <ul class="submenu__list">
        </ul>
      </div>
    `;

    const createFilterMore = document.createElement('div');
    createFilterMore.setAttribute('class', 'filter-search__more');
    createFilterMore.innerHTML = submenu;

    const createFilterList = document.createElement('ul');
    createFilterList.setAttribute('class', 'filter-search__list');

    const createFilterSlideLine = document.createElement('div');
    createFilterSlideLine.setAttribute('class', 'filter-search__slide-line');

    this.filterSearch.appendChild(createFilterList);
    this.filterSearch.appendChild(createFilterSlideLine);

    this.selectOptions.length > this.maxFilterItems
      && this.filterSearch.appendChild(createFilterMore);

    [...this.selectOptions].map((option, i) => {
      option.setAttribute('data-id', i);
      const createOptionItem = document.createElement('li');
      createOptionItem.setAttribute('class', 'filter-search__item');
      createOptionItem.setAttribute('data-id', i);

      const createOptionName = document.createElement('span');
      createOptionName.setAttribute('class', 'filter-search__name');
      createOptionName.innerHTML = option.innerHTML;

      createOptionItem.appendChild(createOptionName);

      createOptionItem.addEventListener('click', e => {
        option.selected = e.target.closest('.filter-search__name');
        option.setAttribute('selected', '');
        this._addClassActive(createOptionItem);
        this.targetForm.submit();
      });

      this.filterSearchList = document.querySelector('.filter-search__list');
      this.filterSearchList.appendChild(createOptionItem);

      if (i >= this.maxFilterItems) {
        const cloneOptionItem = createOptionItem.cloneNode(true);
        cloneOptionItem.setAttribute('class', 'submenu__item');

        orientationType !== 180
          && createOptionItem.setAttribute('style', 'display: none');

        cloneOptionItem.addEventListener('click', () => {
          option.selected = cloneOptionItem;
          option.setAttribute('selected', '');
          this._addClassActive(cloneOptionItem);
          this.targetForm.submit();
        });

        this.filterSearch.querySelector('.submenu__list').appendChild(cloneOptionItem);

      }
      !this.landscapeActive
        && (option.selected
          && this._addClassActive(createOptionItem));
    });

    !this.landscapeActive
      && this._addUnderlineMenu();
  }
}